import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox } from '@entrata/portals-common/lib/boxed-fields/atoms'
import { ChecklistField } from '@entrata/portals-common/lib/boxed-fields'

import styled from '@emotion/styled'

const StyledCheckbox = styled(Checkbox)`
  div:first-child {
    background: ${({ theme, value }) =>
      value
        ? theme.rounded_checkbox.background_blue
        : theme.rounded_checkbox.background_default};
    border: ${({ theme }) =>
      `1px solid ${theme.rounded_checkbox.border_color}`};
    box-sizing: border-box;
    border-radius: 6px;
  }
`

const RoundedChecklistField = React.forwardRef((props, ref) => {
  return <ChecklistField {...props} ref={ref} />
})

RoundedChecklistField.Checkbox = StyledCheckbox
RoundedChecklistField.propTypes = {
  children: PropTypes.node,

  className: PropTypes.string,

  disabled: PropTypes.bool,

  id: PropTypes.string,

  name: PropTypes.string,

  onBlur: PropTypes.func,

  onChange: PropTypes.func,

  onFocus: PropTypes.func,

  value: PropTypes.array,
}
export default RoundedChecklistField
